import { useCallback } from 'react';

import { openSignupPrompt } from '@backrs_ui/grow-ui/src/redux/appState/appState';
import { useAppDispatch } from '@backrs_ui/grow-ui/src/redux/hooks';
import { IS_SANDBOX } from '@backrs_ui/grow-ui/src/utils/sandboxSession';

/** Returns a check that opens the contact prompt and reports true when an action can't run in the sandbox. */
export const useSandboxGate = (): (() => boolean) => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    if (!IS_SANDBOX) return false;

    dispatch(openSignupPrompt('sandbox'));

    return true;
  }, [dispatch]);
};
